import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { faUserLock } from '@fortawesome/pro-solid-svg-icons/faUserLock'
import { faClose } from '@fortawesome/pro-solid-svg-icons/faClose'
import EmptyState from 'components/reusables/emptyState'
import Wrapper from 'components/reusables/wrapper'
import { Container } from '../styled'

const Forbidden = () => {
  const { t } = useTranslation()
  const history = useHistory()
  const translationPrefix = 'errorPages.forbidden'

  return (
    <Wrapper shadow={false}>
      <Container>
        <EmptyState
          title={t(`${translationPrefix}.title`)}
          description={t(`${translationPrefix}.description`)}
          icon={faUserLock}
          iconBackground="#CFE7FD"
          iconColor="#213F68"
          iconBadge={faClose}
          titleColor="#213F68"
          descriptionColor="#213F68"
          titleFontSize="18px"
          descriptionFontSize="16px"
          action={() => history.push('/')}
          actionTitle={t(`${translationPrefix}.action`)}
          actionBackgroundColor="#0085FF"
          actionTitleColor="#FFFFFF"
          padding="134px 32px"
          background="#FFFFFF"
          boxShadow={true}
        />
      </Container>
    </Wrapper>
  )
}

export default Forbidden
